import { useQuery } from '@apollo/client';

import { AccountConnector } from '~/generated/graphql';

import query from './query.graphql';

const connectorServices = ['salesforce', 'salesforcesandbox', 'hubspot'];
const formConnectorServices = ['hubspot', 'marketo'];

export default function useOnboardingStatus() {
  const { data = {}, loading, refetch } = useQuery(query);

  const activeConnectors = data?.account?.connectors.filter(
    (connector: AccountConnector) =>
      connectorServices.includes(connector.service),
  );

  const dataSources = data?.account?.accountSetting?.dataSources || [];

  const {
    salesforce: salesforceEnrichmentMappings,
    hubspot: hubspotEnrichmentMappings,
  } = data?.account?.enrichmentFieldMappings || { salesforce: [], hubspot: [] };

  const formConnectors = data?.account?.connectors.filter(
    (connector: AccountConnector) =>
      formConnectorServices.includes(connector.service),
  );

  const hasConnectors =
    activeConnectors && activeConnectors.length > 0 && !loading;
  const connectorNames = activeConnectors?.map(
    (connector: any) => connector.service,
  );
  const hasEnrichmentFieldMappings =
    salesforceEnrichmentMappings.length > 0 ||
    hubspotEnrichmentMappings.length > 0;
  const hasFormConnectors =
    formConnectors && formConnectors.length > 0 && !loading;
  const hasTagsTraffic =
    Boolean(data?.account?.accountSetting?.firstPageEventReceivedAt) &&
    !loading;
  const hasTamAudience =
    Boolean(data?.account?.accountSetting?.tamAudience) && !loading;
  const hasSkippedOnboarding = Boolean(
    data?.account?.accountSetting?.onboardingSkipped,
  );

  const shouldOnboard =
    (!hasConnectors || !hasTagsTraffic) && !hasSkippedOnboarding && !loading;

  return {
    connectorNames,
    dataSources,
    loading,
    hasConnectors,
    hasEnrichmentFieldMappings,
    hasFormConnectors,
    hasSkippedOnboarding,
    hasTagsTraffic,
    hasTamAudience,
    refetch,
    shouldOnboard,
  };
}
